import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=19555060&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19555060')) {
      api.createRecord('19555060', component.options)
    } else {
      api.reload('19555060', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=19555060&", function () {
      api.rerender('19555060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NMV1k2jn78Dy/JS/offershelp.vue"
export default component.exports